const menuDanish = {
  customerSwitcher: {
    workingAs: "Arbejder som:",
    yourself: "Dig selv",
    onBehalfBanner: "Du arbejder på vegne af {customerName}"
  },
  menuItems: {
    dashboard: "Dashboard",
    linkedInPosts: "LinkedIn Poster",
    aiGenerator: "AI Generator",
    caseGenerator: "Case Generator",
    myPosts: "Mine Opslag",
    imageArchive: "Billedearkiv",
    scheduler: "Planlægger",
    aiSettings: "AI Indstillinger",
    settings: "Indstillinger",
    organization: "Organisation"
  },
  theme: {
    lightTheme: "Lyst tema",
    darkTheme: "Mørkt tema"
  },
  userMenu: {
    billing: "Fakturering",
    logout: "Log ud"
  }
};

export default menuDanish; 